/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable()
export class LiveChatScriptLoaderService {
  public isLoaded$ = new BehaviorSubject(false);

  constructor(@Inject(DOCUMENT) private readonly _document: Document) {}

  public loadScript(): void {
    if (!this.isLoaded$.value) {
      const node = this._document.createElement('script');
      node.src = environment.config.deviceHealthCheckLiveChat.scriptUrl;
      node.type = 'text/javascript';
      node.async = true;
      this._document.getElementsByTagName('head')[0].appendChild(node);

      const scriptLoadIntervalId = setInterval(() => {
        if ((this._document.defaultView as any).icPatronChat) {
          this.isLoaded$.next(true);
          clearInterval(scriptLoadIntervalId);
        }
      }, 100);
    }
  }
}
